(function(){
  const $ = (sel, ctx=document) => ctx.querySelector(sel);
  const $$ = (sel, ctx=document) => Array.from(ctx.querySelectorAll(sel));
  const fmt = (cents) => {
    // Simple Geldformat: nutzt Shopify money_format als Fallback
    return (window.t2Product.moneyFormat || "€{{amount}}")
      .replace("{{amount}}", (cents/100).toFixed(2).replace(".", ","));
  };

  const form = $("#t2p-form");
  if(!form) return;

  const variants = window.t2Product.variants || [];
  const pillGroups = $$(".t2p-option");
  const priceEl = $("#t2p-price");
  const stockEl = $("#t2p-stock");
  const idInput = $("#t2p-variant-id");
  const qtyInput = $("#t2p-qty");

  // Wechsel Hauptbild bei Thumb-Klick
  $$(".t2p-thumb").forEach(btn=>{
    btn.addEventListener("click", ()=>{
      const src = btn.getAttribute("data-t2p-src");
      const img = $(".t2p-media-main-img");
      if(img && src) img.src = src;
    });
  });

  // Optionen klicken
  pillGroups.forEach(group=>{
    const index = Number(group.getAttribute("data-index"));
    group.addEventListener("click", (e)=>{
      const pill = e.target.closest(".t2p-pill");
      if(!pill || pill.classList.contains("is-disabled")) return;

      // active togglen
      $$(".t2p-pill", group).forEach(p=>p.classList.remove("is-active"));
      pill.classList.add("is-active");

      // Label aktualisieren
      const current = $(`[data-t2p-option-current="${index}"]`);
      if(current) current.textContent = pill.getAttribute("data-t2p-value");

      updateVariant();
    });
  });

  function getSelectedOptions(){
    // liest aktuell aktive Pills je Option
    return pillGroups.map(g=>{
      const active = $(".t2p-pill.is-active", g);
      return active ? active.getAttribute("data-t2p-value") : null;
    });
  }

  function findVariantByOptions(values){
    return variants.find(v=>{
      return v.options.every((opt, i)=> String(opt) === String(values[i]));
    });
  }

  function updateVariant(){
    const values = getSelectedOptions();
    const variant = findVariantByOptions(values);
    if(!variant) return;

    idInput.value = variant.id;

    if(priceEl) priceEl.textContent = fmt(variant.price);

    if(stockEl){
      stockEl.textContent = variant.available ? "✓ Sofort lieferbar 3 - 7 Werktage" : "✕ Ausverkauft";
    }

    const addBtn = $("#t2p-add");
    if(addBtn){
      addBtn.disabled = !variant.available;
      addBtn.classList.toggle("is-disabled", !variant.available);
    }
  }

  // Stepper
  $(".t2p-step.-minus")?.addEventListener("click", ()=>{
    const val = Math.max(1, (parseInt(qtyInput.value||"1",10)-1));
    qtyInput.value = val;
  });
  $(".t2p-step.-plus")?.addEventListener("click", ()=>{
    const val = Math.max(1, (parseInt(qtyInput.value||"1",10)+1));
    qtyInput.value = val;
  });

  // Init
  updateVariant();
})();
